// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadfull {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(63, 156, 232, 0.2);\n  z-index: 999999;\n  color: #FFF;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
